// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"iq","modify_order":"jq","modify_order_header":"kq","product_details_form_wrapper":"lq","c_wrapper":"mq","save_button":"nq","title":"oq","modify_order_title_wrapper":"pq","note":"qq","buttons_wrapper":"rq"};
    if(module.hot) {
      // 1713912563086
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  